import { WSElement, WSTableCell } from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useBulkPayableBatchSummary } from "../../query/bulkPayable/queries";

export function BulkBatchImportTotal({ batchId }: { batchId: string }) {
  const qBulkPayableBatchItems = useBulkPayableBatchSummary(batchId);

  if (qBulkPayableBatchItems.isLoading) {
    return <WSElement shimmer={true}>loading</WSElement>;
  }

  return (
    <WSTableCell
      text={formatMoney(qBulkPayableBatchItems.data?.netImportAmount!, "USD")}
    />
  );
}
